import Api from '../shared/Api';

class SystemInfoApi {
    static getSystemInfo(): any {
        return new Api().get('/info');
    }

    static getSystemDateTime() {
        return new Api().get('/info/datetime');
    }
}

export default SystemInfoApi;
